import { asText } from '@prismicio/helpers';
import { PrismicRichText } from '@prismicio/react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import QuoteIcon from './assets/quote-icon.svg';
import StarsIcon from './assets/stars.svg';

import { transformProperties, fieldHasContent } from '@/src/domains/prismic/helpers';
import { desktopBreakpoint } from '@/src/domains/shared/breakpoints';
import { Section as SectionComponent } from '@/src/views/G2LeaderPage/GridReportSlice';

export const Section = styled(SectionComponent)`
  --boldTextBgColor: #dfefd3;

  font-family: var(--typography-fontBossa);
  ${fluidProp(['padding-bottom', 'padding-top'], '80px', '145px')}
  text-align: center;
  color: var(--colors-darkBlue);
  background: var(--colors-blank);
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.scale3}

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const SubTitle = styled.div`
  ${({ theme }) => theme.typography.titleMD}
  font-weight: 400;
  margin: 18px 0 60px 0;
  font-family: var(--typography-fontBrand);
`;

export const Name = styled.div`
  ${({ theme }) => theme.typography.titleXL}
  font-weight: 700;
`;

export const Position = styled(Name)`
  font-weight: 400;
`;

export const Description = styled.div`
  ${({ theme }) => theme.typography.titleMD}
  font-weight: 400;
  ${fluidProp('line-height', '31px', '41px')}
  margin-bottom: 38px;

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const QuoteBold = styled(Description)`
  margin: 30px 0 10px 0;

  span {
    background-color: var(--boldTextBgColor);
    box-shadow: 15px 0 0 var(--boldTextBgColor), -15px 0 0 var(--boldTextBgColor);
    padding: 15px 0;
    font-weight: 700;

    ${desktopBreakpoint(css`
      box-shadow: 5px 0 0 var(--boldTextBgColor), -5px 0 0 var(--boldTextBgColor);
      padding: 5px 0;
    `)}
  }
`;

export function QuoteSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, subtitle, quoteBold, quote, name, position } = primary;

  return (
    <Section id="quote">
      <ContentContainer>
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        {fieldHasContent(subtitle) && <SubTitle>{subtitle}</SubTitle>}
        <QuoteIcon />
        {fieldHasContent(quoteBold) && (
          <QuoteBold>
            <span>{asText(quoteBold)}</span>
          </QuoteBold>
        )}
        {fieldHasContent(quote) && (
          <Description>
            <PrismicRichText field={quote} />
          </Description>
        )}
        <StarsIcon />
        {fieldHasContent(name) && (
          <Name>
            <PrismicRichText field={name} />
          </Name>
        )}
        {fieldHasContent(position) && (
          <Position>
            <PrismicRichText field={position} />
          </Position>
        )}
      </ContentContainer>
    </Section>
  );
}
